import React from "react";
import { GrClose } from "react-icons/gr";
import styles from "./remove-btn.module.scss";

type Props = {
  handleFunction: (val: any) => void;
};

const RemoveBtn = ({ handleFunction }: Props) => {
  return (
    <div
      className={styles.removeCollectionBtn}
      role="button"
      onClick={handleFunction}>
      <GrClose size={14} />
    </div>
  );
};

export default RemoveBtn;
